import React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { Redirect, Link as RouterLink } from 'react-router-dom';

import { ListSubheader } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import ApiManager from '../../../Api/ApiManager';
import {ApiContextProps, withApi} from '../Context/ApiContext';

export interface UserActionButtonProps extends InjectedIntlProps, ApiContextProps {}

interface UserActionButtonState {
  redirectToAuth: boolean;
  anchorEl: HTMLElement;
}

class UserActionButton extends React.Component<UserActionButtonProps, UserActionButtonState> {
  constructor(props: UserActionButtonProps) {
    super(props);
    this.state = {
      anchorEl: null,
      redirectToAuth: false,
    };
  }

  handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogout = () => {
    if (ApiManager.logout()) {
      this.handleClose();
      this.setState({
        redirectToAuth: true,
      });
    }
  };

  render() {
    const { redirectToAuth, anchorEl } = this.state;
    if (redirectToAuth) {
      return <Redirect to="/auth" />;
    }

    const { apiManager, intl } = this.props;
    const open = Boolean(anchorEl);
    return (
      <div>
        <IconButton
          aria-owns={open ? 'menu-appbar' : null}
          aria-haspopup="true"
          onClick={this.handleMenu}
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={this.handleClose}
          MenuListProps={{
            subheader: <ListSubheader component="div" id="nested-list-subheader">{intl.formatMessage({ id: 'userProfile.settings.title' })}</ListSubheader>,
            disablePadding: true
          }}
        >
          <MenuItem onClick={this.handleClose} component={RouterLink} to="/user">{intl.formatMessage({ id: 'userProfile.settings.profileText' })}</MenuItem>
          <MenuItem>
            <Link href={apiManager.adminApi.ADMIN_HOME} rel="noopener" color="inherit" target="_blank">
              {intl.formatMessage({ id: 'userProfile.settings.adminText' })}
            </Link>
          </MenuItem>
          <Divider />
          <MenuItem onClick={this.handleLogout}>{intl.formatMessage({ id: 'logout' })}</MenuItem>
        </Menu>
      </div>
    );
  }
}

export default injectIntl(withApi(UserActionButton));
